/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Button, Icon } from '@pwc/pwc-deals-ui';
import { useTranslation } from 'react-i18next';
import useMobile from 'common/hooks/useMobile';
import { getIsDarkModeSelector } from 'common/redux/userSettings/userSettingsSlice';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import './VersioningPanel.scss';

type Props = {
  isPanelOpened: boolean;
  onClose: () => void;
};

const VersioningPanelHeader: FC<Props> = ({ isPanelOpened, onClose }) => {
  const isMobile = useMobile();
  const darkMode = useSelector(getIsDarkModeSelector);
  const { t } = useTranslation('');
  return (
    <div className="versioning-panel-header">
      {isPanelOpened && (
        <div
          className="versioning-panel-header__label"
          role="heading"
          aria-level={1}
          data-testid="versioning-panel-header__label"
        >
          {t('versionHistory')}
        </div>
      )}

      <Button
        className="panel-button"
        aria-label="versioning icon"
        data-testid="versioning-button"
        onClick={onClose}
        icon={undefined}
        iconClasses={undefined}
      >
        {isMobile && darkMode && (
          <Icon name="tooltip-close-darkMode" width="34" height="32" />
        )}
        {isMobile && !darkMode && (
          <Icon name="tooltip-close-lightMode" width="34" height="32" />
        )}
        {!isMobile && (
          <Icon name="close" className="fill icon-orange" width="18" />
        )}
      </Button>
    </div>
  );
};

export default VersioningPanelHeader;
